import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Current names of available effects. To create a new effect, create a new particle effect
 * component in ./particle-effects and then add the name to this enum while also adding it to
 * the template in the particle-effects-overlay.component.html;
 */
export enum ParticleEffects {
  SNOW,
}

@Injectable({
  providedIn: 'root',
})
export class ParticleEffectsOverlayService {
  private overlayTrigger: BehaviorSubject<ParticleEffects | undefined> = new BehaviorSubject<
    ParticleEffects | undefined
  >(undefined);
  constructor() {}

  public getTrigger(): Observable<ParticleEffects | undefined> {
    return this.overlayTrigger.asObservable();
  }

  public loadParticleEffect(effect: ParticleEffects) {
    this.overlayTrigger.next(effect);
  }

  public removeParticleEffect() {
    this.overlayTrigger.next(undefined);
  }
}
